/**
 * Desktop notification utility using the Browser Notification API.
 * showDesktopNotification only fires when permission is already granted.
 * requestNotificationPermission must be called from a user-gesture handler.
 */

export async function showDesktopNotification(title, body, options = {}) {
  if (!('Notification' in window)) return;
  if (Notification.permission !== 'granted') return;

  const notification = new Notification(title, {
    body,
    icon: '/favicon/favicon-32x32.png',
    badge: '/favicon/favicon-32x32.png',
    ...options,
  });

  // Auto-close after 5 seconds
  setTimeout(() => notification.close(), 5000);
  return notification;
}

export async function requestNotificationPermission() {
  if (!('Notification' in window)) return;
  if (Notification.permission === 'granted' || Notification.permission === 'denied') return;
  await Notification.requestPermission();
}
